import React from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
import Button from '../button/button';
const Control = _ref => {
  let {
    activePage,
    ariaLabel,
    children,
    index,
    onClick
  } = _ref;
  const cl = buildVersionedClassNames('ds-pagination__list__item', {
    'ds-pagination__list__item--active': activePage === index
  });
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    "aria-current": activePage === index ? 'page' : undefined,
    "aria-label": ariaLabel,
    className: cl,
    compact: true,
    href: "#!",
    onClick: onClick
  }, children));
};
export default Control;